
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 1.137C5.1051 1.137 1.137 5.1051 1.137 10C1.137 14.8949 5.1051 18.863 10 18.863C14.8949 18.863 18.863 14.8949 18.863 10C18.863 5.1051 14.8949 1.137 10 1.137ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10ZM9.99899 2.69544C10.313 2.69544 10.5675 2.94996 10.5675 3.26393V5.38885H11.3452C12.7759 5.38885 13.935 6.54792 13.935 7.97867C13.935 8.65824 13.6735 9.27652 13.2457 9.73841C14.0586 10.1752 14.6111 11.0335 14.6111 12.0213C14.6111 13.4521 13.4521 14.6111 12.0213 14.6111H10.5675V16.7361C10.5675 17.05 10.313 17.3046 9.99899 17.3046C9.68502 17.3046 9.43049 17.05 9.43049 16.7361V14.6111H7.30355C6.98958 14.6111 6.73506 14.3566 6.73506 14.0426V5.95735C6.73506 5.64338 6.98958 5.38885 7.30355 5.38885H9.43049V3.26393C9.43049 2.94996 9.68502 2.69544 9.99899 2.69544ZM7.87205 6.52585V9.4315H11.3452C12.148 9.4315 12.798 8.78148 12.798 7.97867C12.798 7.17587 12.148 6.52585 11.3452 6.52585H7.87205ZM7.87205 10.5685V13.4742H9.96478C9.9761 13.4735 9.9875 13.4731 9.99899 13.4731C10.0105 13.4731 10.0219 13.4735 10.0332 13.4742H12.0213C12.8241 13.4742 13.4742 12.8241 13.4742 12.0213C13.4742 11.2185 12.8241 10.5685 12.0213 10.5685H7.87205Z","fill":"#A1AAC6"}})])
          )
        }
      }
    